var exports = {
  "kL": "x4c3adb35--b70099--container",
  "_8": "x4c3adb35--b70099--img",
  "p2": "x4c3adb35--b70099--text-info",
  "qU": "x4c3adb35--b70099--one-column",
  "Cv": "x4c3adb35--b70099--two-column",
  "kb": "x4c3adb35--b70099--left",
  "pG": "x4c3adb35--b70099--right",
  "Im": "x4c3adb35--b70099--comment",
  "O0": "x4c3adb35--b70099--rating",
  "uf": "x4c3adb35--b70099--stars",
  "Yq": "x4c3adb35--b70099--reviews",
  "UU": "x4c3adb35--b70099--name",
  "s6": "x4c3adb35--b70099--agent-name",
  "Tq": "x4c3adb35--b70099--participations",
  "qS": "x4c3adb35--b70099--badge",
};

module.exports = exports;
